import { i18n } from "@/i18n";
import { AbilityBuilder } from "@casl/ability";
import { abilitiesPlugin } from "@casl/vue";
import VCalendar from "v-calendar";
import vClickOutside from "v-click-outside";
import Vue from "vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css";
import Croppa from "vue-croppa";
import "vue-croppa/dist/vue-croppa.css";
import VueDragscroll from "vue-dragscroll";
import FlagIcon from "vue-flag-icon";
import GSignInButton from "vue-google-signin-button";
import VueIntercom from "vue-intercom";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { SlickItem, SlickList } from "vue-slicksort";
import vueSocketIO, { VueSocketOptions } from "vue-socket.io";
import App from "./App.vue";
import "./extensions";
import "./globalComponentRegistration";
import { AuthorizeModels, SetLastUrl } from "./helper/routerHelper";
import { CheckIsMUZE } from "./helper/shareHelper";
import router from "./router";
import { DatadogRumService } from "./service/datadog/datadogRumService";
import store from "./store";

const IsMUZE = CheckIsMUZE();

Vue.use(VueAwesomeSwiper);

Vue.use(GSignInButton);
if (!IsMUZE) {
  Vue.use(VueIntercom, { appId: process.env.VUE_APP_PeakIntercom });
}

Vue.component("multiselect", Multiselect);

Vue.use(Croppa);

Vue.use(vClickOutside);

Vue.use(VCalendar, {
  componentPrefix: "v",
  backgroundColor: "#282C34",
  border: "1px solid #dadada",
});

Vue.component("SlickList", SlickList);
Vue.component("SlickItem", SlickItem);

Vue.use(VueDragscroll);

Vue.use(FlagIcon);

interface CustomVueSocketOptions extends VueSocketOptions {
  options?: any;
}

Vue.use(
  new vueSocketIO({
    debug: false,
    connection: process.env.VUE_APP_PeakNotification,
    vuex: {
      store,
      actionPrefix: "SOCKET_",
      mutationPrefix: "SOCKET_",
    },
    options: {
      autoConnect: false,
    },
  } as CustomVueSocketOptions)
);

Vue.config.productionTip = false;

function defineAbilityFor() {
  const { can, cannot, build } = new AbilityBuilder();
  return build();
}
const ability = defineAbilityFor();

Vue.use(abilitiesPlugin, ability);

router.beforeEach((to, from, next) => {
  AuthorizeModels(to.name);
  SetLastUrl(to);
  next();
});

router.onError((error) => {
  const regex = new RegExp(/Loading .* failed\./i);
  if (regex.test(error.message)) {
    window.location.href = `${window.location.href}update.html?v=${new Date().getTime()}`;
  }
});

if (!IsMUZE) {
  DatadogRumService.Init();
}

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
